export const THEME = 'theme';
export const DARK = 'dark';
export const LIGHT = 'light';
export const SYSTEM_DEFAULT = 'system';
